module.exports = "https://img1.huilianyi.com/4/create-loanbill@3x.48bf28db59.appcore.png";